export const CATEGORIES_ACTION_TYPE = {
  SET_CATEGORIES: "category/SET_CATEGORIES_MAP",
};
